module.exports = __webpack_public_path__ + "img/instagram-circle.81d758dc.svg";